var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chat-btm-section-main width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-web-section chat-user-list-main float-l width-full"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "logout-btn float-r" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "btn btn-primary internal-large-btn",
                                    attrs: {
                                      to: { name: "AddSectionScheduleTime" }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "gradient" }),
                                    _vm._v(
                                      " Add Scheduler\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "vue-good-table",
                              {
                                ref: "listScheduleSection",
                                attrs: {
                                  mode: "remote",
                                  title: "Schedule Section",
                                  totalRows: _vm.totalRecords,
                                  columns: _vm.columns,
                                  rows: _vm.rows,
                                  "pagination-options": {
                                    enabled: true,
                                    position: "bottom",
                                    perPage: 10,
                                    dropdownAllowAll: false
                                  },
                                  "select-options": {
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: "custom-class",
                                    selectionText: "rows selected",
                                    clearSelectionText: "Clear"
                                  },
                                  "search-options": {
                                    enabled: false
                                  }
                                },
                                on: {
                                  "on-page-change": _vm.onPageChange,
                                  "on-selected-rows-change":
                                    _vm.selectionChanged,
                                  "on-column-filter": _vm.onColumnFilter,
                                  "on-per-page-change": _vm.onPerPageChange,
                                  "on-sort-change": _vm.onSortChange
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm._l(_vm.rows, function(row, key) {
                                      return {
                                        key: "table-row",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                key: key,
                                                staticClass: "user-list-view"
                                              },
                                              [
                                                props.column.field == "action"
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Edit Schedule Section",
                                                              to: {
                                                                name:
                                                                  "UpdateSectionScheduleTime",
                                                                params: {
                                                                  id:
                                                                    props.row.id
                                                                }
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-success waves-effect row-activate-btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.deleteSchedule(
                                                                  props.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                props.column.field ==
                                                "sectionRoleHtml"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btn-center-vvg"
                                                      },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              props
                                                                .formattedRow[
                                                                props.column
                                                                  .field
                                                              ]
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            props.formattedRow[
                                                              props.column.field
                                                            ]
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ])
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    })
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "selected-row-actions" },
                                    slot: "selected-row-actions"
                                  },
                                  [
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-success waves-effect row-activate-btn",
                                          attrs: { id: "deleteGroupBtn" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.deleteSchedule(0)
                                            }
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "user-list-mobile float-l width-full"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "large-btn float-l width-full" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: "AddSectionScheduleTime" }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Add Scheduler\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mobile-class-userlist" },
                              [
                                _vm.rows && _vm.rows.length > 0
                                  ? _vm._l(_vm.rows, function(
                                      section,
                                      sectionIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: sectionIndex,
                                          staticClass:
                                            "user-list-section col-12 float-l relative pt_20 pb_20"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox mb_3"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label float-l width-full heading-text-16 line-height-20 color-333333 font-benton-medium pl_15",
                                                  attrs: { for: "customCheck" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "user-name-mobile"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            section.section_name
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-888888 float-l width-full font-text-regular-benton heading-text-13 line-height-17 pt_3"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            section.start_time
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            section.end_time
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    title:
                                                      "Edit Schedule Section Time",
                                                    to: {
                                                      name:
                                                        "UpdateSectionScheduleTime",
                                                      params: { id: section.id }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-angle-right"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              : [_vm.isRequestComplete ? [_vm._m(1)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      {
        staticClass:
          "chat-page-title float-l colpie-80 color-333333 heading-text-24 line-height-28 font-bold ucase"
      },
      [
        _vm._v(
          " \n                                Schedule Section \n                                "
        ),
        _c("span", [_vm._v("(All times are in Sydney)")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e181d68c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e181d68c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionScheduler/ListSectionSchedulerTime.vue
// module id = null
// module chunks = 